<section class="loading-file" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="16px">
  <div fxLayout="row">
    <img src="/assets/icons/illustrations/img-loading.svg" alt="loading-image" />
  </div>
  <h1 class="title" fxLayout="row" fxLayoutAlign="center start">{{ getTitle() }}</h1>
  <p class="b1 text">{{ getText() }}</p>
</section>
